import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getWishlistCounts } from "@/lib/api";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const [counts, setCounts] = useState({});

  const refresh = useCallback(() => {
    getWishlistCounts()
      .then((map) => setCounts(map || {}))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const bump = (slug, delta) =>
    setCounts((c) => ({ ...c, [slug]: Math.max(0, (c[slug] || 0) + delta) }));

  return (
    <WishlistContext.Provider value={{ counts, bump, refresh }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
